import { useForYouChatsFeed } from '@renderer/overlay/hooks/use-running-chats'
import { useForYouDisplayChats } from '@renderer/overlay/hooks/for-you-linger'
import { countForYouUnreadChats } from '@renderer/overlay/hooks/running-chat-selection'

/** Keeps the Home pill and dock on the same linger-resolved count. */
export function useForYouUnreadCount(): number {
  const { data: chats, feedKey } = useForYouChatsFeed()
  const displayChats = useForYouDisplayChats(chats, feedKey)
  return countForYouUnreadChats(displayChats)
}
